import React from 'react';
import { func, object } from 'prop-types';
import styled from 'styled-components';
import SwitchButton from './SwitchButton';

const Text = styled.p`
  opacity: ${props => (props.active ? 1.0 : 0.6)};
  font-size: 11px;
  font-weight: bold;
  color: #4a4a4a;
  text-transform: uppercase;
  padding: 0px 15px;
`;

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 32px;
`;

const SwitchStep = ({ onClick, currentStep }) => {
  const width = window.innerWidth;
  const highlightsText = width <= 1000 ? 'Só esse anúncio' : 'Publicar só esse anúncio';
  const subscriptionText = width <= 1000 ? 'Planos Profissionais' : 'Contratar um Plano profissional';

  return (
    <Container>
      <Text active={currentStep.name === 'highlights-subscription'}>{highlightsText}</Text>
      <SwitchButton onClick={onClick} active={currentStep.name === 'subscription'} />
      <Text active={currentStep.name === 'subscription'}>{subscriptionText}</Text>
    </Container>
  );
};

SwitchStep.propTypes = {
  onClick: func.isRequired,
  currentStep: object.isRequired,
};

export default SwitchStep;
